import React, { Component } from "react";
import { Link } from "react-router-dom";

class Search extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSearchResultEmpty: false,
      searchResult: []
    };
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    document.title = "Search";
    if (document.querySelector(".search-page-input").value === "") {
      document.querySelector(".search-page-result").style.display = "none";
    }
  }

  onChange(e) {
    this.setState({ isSearchResultEmpty: false });
    let searchElem = document.querySelector(".search-page-result");
    let searchValues = e.target.value;
    if (searchValues === "") {
      searchElem.style.display = "none";
      return;
    }
    searchElem.style.display = "block";

    fetch(`${this.props.apiROOT}others/search/${searchValues}`)
      .then(res => res.json())
      .then(data => {
        if (data.searchResult.length > 0) {
          this.setState({ searchResult: data.searchResult });
        } else {
          this.setState({ isSearchResultEmpty: true });
        }
      })
      .catch(err => {
        console.log(err);
      });
  }

  render() {
    return (
      <div
        style={{
          width: 100 + "%",
          display: "block",
          padding: 5 + "px " + 0
        }}
      >
        <input
          onChange={this.onChange}
          className="search-page-input"
          type="text"
          placeholder="Search users, posts..."
          style={{ marginTop: -3, height: 40 }}
        />
        <ul className="search-page-result" style={{ width: 98 + "%" }}>
          {this.state.isSearchResultEmpty === false &&
            this.state.searchResult.map((res, i) =>
              "username" in res ? (
                <li key={i}>
                  <Link
                    to={`/user/${res.username.replace(/ /g, "-")}-${
                      res.user_id
                    }`}
                  >
                    <span style={{ fontWeight: 600, marginRight: 5 }}>
                      User:{" "}
                    </span>
                    {res.username}
                  </Link>
                </li>
              ) : (
                <li key={i}>
                  <a
                    href={`${this.props.root}post/${res.post_title
                      .replace(/ /g, "-")
                      .replace(/\?/g, "")}-${res.post_id}`}
                  >
                    <span style={{ fontWeight: 600, marginRight: 5 }}>
                      {res.post_type}:{" "}
                    </span>
                    {res.post_title}
                  </a>
                </li>
              )
            )}

          {this.state.isSearchResultEmpty === true && <li>No search result</li>}
        </ul>
      </div>
    );
  }
}

export default Search;
